var Kowloon = "Kowloon";
var HKStates = {
	"Hong Kong Island": "Isla de Hong Kong",
	Kowloon: Kowloon,
	"Lantau Island": "Isla Lantau",
	"New Territories": "Nuevos territorios"
};

export { Kowloon, HKStates as default };
